export const API_BASE_ADDRESS = process.env.API_BASE_ADDRESS;

export const OAUTH_PLATFORMS = {
  AMAZON: 'amazon',
  REDDIT: 'reddit',
  TIKTOK: 'tiktok',
  VIANT: 'viant',
} as const;

export const OAUTH_PLATFORM_LABELS = {
  [OAUTH_PLATFORMS.AMAZON]: 'Amazon',
  [OAUTH_PLATFORMS.REDDIT]: 'Reddit',
  [OAUTH_PLATFORMS.TIKTOK]: 'TikTok',
  [OAUTH_PLATFORMS.VIANT]: 'Viant',
};

export const OAUTH_AD_ACCOUNT_LABELS = {
  [OAUTH_PLATFORMS.AMAZON]: 'Amazon Advertiser ID',
  [OAUTH_PLATFORMS.REDDIT]: 'Reddit Ad Account ID',
  [OAUTH_PLATFORMS.TIKTOK]: 'TikTok Advertiser ID',
  [OAUTH_PLATFORMS.VIANT]: 'Viant Client ID',
};

export const OAUTH_PLATFORM_OPTIONS = [
  { id: 'all', label: 'All' },
  {
    id: OAUTH_PLATFORMS.AMAZON,
    label: OAUTH_PLATFORM_LABELS[OAUTH_PLATFORMS.AMAZON],
  },
  {
    id: OAUTH_PLATFORMS.REDDIT,
    label: OAUTH_PLATFORM_LABELS[OAUTH_PLATFORMS.REDDIT],
  },
  {
    id: OAUTH_PLATFORMS.TIKTOK,
    label: OAUTH_PLATFORM_LABELS[OAUTH_PLATFORMS.TIKTOK],
  },
  {
    id: OAUTH_PLATFORMS.VIANT,
    label: OAUTH_PLATFORM_LABELS[OAUTH_PLATFORMS.VIANT],
  },
];

export const API_ENDPOINT = `${API_BASE_ADDRESS}/audience-studio/oauth-url`;
